import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Document, Page, pdfjs } from "react-pdf";
import "../assets/css/DetailPage.css";
import img1 from "../assets/images/3.webp";

// ✅ PDF worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PreSalesDetail() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const fullUrl = window.location.href;
  const { id } = useParams();
  const navigate = useNavigate();
  const department = ['admin', 'marketing', 'presales', 'research', 'sales'];
  const [proposalDocs, setProposalDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const userId = sessionStorage.getItem("user_id");
  const userDepartment = sessionStorage.getItem("user_department");
  let first_tool_tip = "", first_value = "", second_tool_tip = "", second_value = "";

  // ✅ Fetch data on mount
  useEffect(() => {
    const urlParts = fullUrl.split("/");
    const pdocid = urlParts[urlParts.length - 1] || "";
    const category = urlParts[urlParts.length - 2] || "";


    axios
      .post(`${BASE_URL}/presales/details-api/`, {
        category: category,
        id: pdocid,
        userId: userId,
      })
      .then((res) => {
        const data = res.data;

        if (data.title && data.title !== "nan") {
          setProposalDocs(data); // store single object
        } else {
          setProposalDocs(null);
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleRequest = async () => {
    await axios.post(`${BASE_URL}/access-control/api/request-download/`, {
      drive_id: proposalDocs.drive_id,
      item_id: proposalDocs.item_id,
      module: "presales",
      userId: userId,
      category: proposalDocs.category,
      docID: proposalDocs.id,
    });

    // refresh status
    setProposalDocs({
      ...proposalDocs,
      download_status: "pending",
    });
  };

  const handleBookmark = async () => {
    try {
      await axios.post(`${BASE_URL}/access-control/api/add-bookmark/`, {
        drive_id: proposalDocs.drive_id,
        item_id: proposalDocs.item_id,
        module: "presales",
        userId: userId,
        category: proposalDocs.category,
        docID: proposalDocs.id,
        title: proposalDocs.title,
        siteUrl: fullUrl,
      });

      // Toggle UI state
      setIsBookmarked((prev) => !prev);

    } catch (err) {
      console.error("Bookmark error:", err);
    }
  };

  const handleDownload = () => {
    window.open(
      `${BASE_URL}/access-control/api/download?drive_id=${proposalDocs.drive_id}&item_id=${proposalDocs.item_id}`
    );
  };

  const handleDeleteBookmark = async () => {
    try {
      await axios.post(
        `${BASE_URL}/access-control/api/delete-bookmarked/`,
        {
          drive_id: proposalDocs.drive_id,
          item_id: proposalDocs.item_id,
          module: "presales",
          userId: userId,
          category: proposalDocs.category,
          docID: proposalDocs.id,
        }
      );

      // ✅ Remove from UI instantly
      setIsBookmarked((prev) => !prev);

    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  // ✅ Match record using slug
  const pdoc = proposalDocs;
  if (pdoc.category === "pre_case_studies") {
    first_tool_tip = "Industry";
    first_value = pdoc.industry;
    second_tool_tip = "Service/Area";
    second_value = pdoc.service_area;
  } else if (pdoc.category === "domain_capabilities") {
    first_tool_tip = "Domain";
    first_value = pdoc.domain;
    second_tool_tip = "Area";
    second_value = pdoc.area;
  } else {
    first_tool_tip = "Service";
    first_value = pdoc.service;
    second_tool_tip = "Area";
    second_value = pdoc.area;
  }

  if (!pdoc) {
    return (
      <div className="container py-5 text-center">
        <h3>Document not found</h3>
        <button className="btn btn-secondary mt-3" onClick={() => navigate("/")}>
          Go Back
        </button>
      </div>
    );
  }

  return (

    <div className="poc-detail container-fluid py-5" >
      <div className="container">
        <div className="row">
          {/* LEFT COLUMN */}
          <div className="col-md-5 col-sm-12 left-panel">
            {/* download action btn  */}
            {pdoc.download_status === "approved" || department.includes(userDepartment) ? (
              <button onClick={handleDownload} className="btn downloadbtn mt-3">Download {pdoc.category == "service_capabilities" ? 'Service Capability' : pdoc.category == "domain_capabilities" ? 'Domain Capability' : 'Presales Case Study'}</button>
            ) : pdoc.download_status === "pending" ? (
              <button disabled className="btn downloadbtn mt-3">Pending Approval - {pdoc.category == "service_capabilities" ? 'Service Capability' : pdoc.category == "domain_capabilities" ? 'Domain Capability' : 'Presales Case Study'}</button>
            ) : (
              <button onClick={handleRequest} className="btn downloadbtn mt-3">Request Download - {pdoc.category == "service_capabilities" ? 'Service Capability' : pdoc.category == "domain_capabilities" ? 'Domain Capability' : 'Presales Case Study'}</button>
            )}

            <h2>{pdoc.title}</h2>
            <p>
              <span className="tooltip-container">
                {first_value}
                <span className="tooltip-text">{first_tool_tip}</span>
              </span>
              <span className="tooltip-container">
                | {second_value}
                <span className="tooltip-text">{second_tool_tip}</span>
              </span>
            </p>
            {pdoc.category === "pre_case_studies" ? (
              <>
                <p className="sub-heading">Customer Details</p>

                <table className="table-cls">
                  <tbody>
                    <tr>
                      <th width="20%">Name</th>
                      <td width="80%">{pdoc.customer_name}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>{pdoc.customer_type}</td>
                    </tr>
                    <tr>
                      <th>About</th>
                      <td>{pdoc.about_customer}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            ) : null}
            {pdoc.category === "pre_case_studies" || pdoc.category === "service_capabilities" ?
              <>
                <p class="sub-heading">Tech Stacks</p>
                <p>{pdoc.tech_stack?.trim() ? pdoc.tech_stack : "Data not found"}</p>
              </>
              : null}
            <p class="sub-heading">Keywords</p>
            <p>{pdoc.keywords}</p>
            {pdoc.category === "service_capabilities" || pdoc.category === "domain_capabilities" ? (
              <>
                <p class="sub-heading">Description</p>
                <p>{pdoc.description}</p>

              </>
            ) : null}
          </div>
          {/* RIGHT COLUMN (PDF VIEWER) */}
          <div className="col-md-7 col-sm-12 right-panel">
            <div className="pdf-wrapper">
              {pdoc.sharepoint_embed_link ? (
                <iframe
                  src={pdoc.sharepoint_embed_link}
                  width="600"
                  height="500"
                  allowFullScreen
                  style={{ overflow: "hidden" }}
                  title={pdoc.title}
                />
              ) : (
                <div className="text-center text-muted py-5">
                  <p>No PDF available for this Resource.</p>
                </div>
              )}

            </div>
            <p class="doc_name">{pdoc.doc_name}</p>
            {/* bookmark btn  */}
            {!isBookmarked ?
              <button onClick={handleBookmark} className="btn bookmarkbtn mt-3"><i className="fa fa-bookmark"></i></button>
              :
              <button onClick={(e) => {
                e.stopPropagation();
                handleDeleteBookmark();
              }} className="btn bookmarkbtn mt-3"><i className="fa fa-times"></i></button>

            }
          </div>
          <div className="col-md-12 col-sm-12 left-panel">
            {pdoc.category === "pre_case_studies" ? (
              <>
                <p class="sub-heading">Description</p>
                <p>{pdoc.description}</p>

              </>
            ) : null}

          </div>
        </div>
      </div>
    </div>
  );
}
